import { PapiDeviation } from '@wix/da-papi-types';
import { Url } from '@wix/da-url';
import { natural } from '../helpers';

export function makeEmptyDeviation(): PapiDeviation {
  return {
    deviationId: natural(),
    typeId: 1,
    isJournal: false,
    isCommentable: false,
    isAntisocial: false,
    isBlocked: false,
    isDeleted: false,
    isDownloadable: false,
    isFavourited: false,
    isMature: false,
    isShareable: false,
    isPurchasable: false,
  };
}

// ---- backgrounds
export function getDeviationBackground() {
  const bgUrl = path => Url.staticCDNLink(`deviations/backgrounds/${path}`);
  return {
    backgroundId: 46,
    position: 45,
    isPremium: true,
    darkThumbUrl: bgUrl('core/ziggy-dark-thumb.png?1'),
    darkBigUrl: bgUrl('core/ziggy-dark-large.png'),
    darkSmallUrl: bgUrl('core/ziggy-dark-small.png'),
    lightThumbUrl: bgUrl('core/ziggy-light-thumb.png?1'),
    lightBigUrl: bgUrl('core/ziggy-light-large.png'),
    lightSmallUrl: bgUrl('core/ziggy-light-small.png'),
    greenThumbUrl: bgUrl('core/ziggy-green-thumb.png?1'),
    greenBigUrl: bgUrl('core/ziggy-green-large.png'),
    greenSmallUrl: bgUrl('core/ziggy-green-small.png'),
  };
}
